/**
 * Lightweight conversion-tracking shim. Fires GA4 + Meta Pixel events
 * if (and only if) those scripts have been loaded via the admin SEO
 * Footer Tracking Code. No-op otherwise — never throws.
 */

export function trackLead({ caseType, assetRange } = {}) {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", {
        currency: "USD",
        value: 0,
        case_type: caseType,
        asset_range: assetRange,
      });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "Lead", {
        content_category: caseType,
      });
    }
  } catch {
    /* never throw */
  }
}

export function trackPurchase({ transactionId, value, currency = "USD", serviceType, serviceName }) {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "purchase", {
        transaction_id: transactionId,
        value: Number(value || 0),
        currency,
        items: [{ item_id: serviceType, item_name: serviceName, price: Number(value || 0), quantity: 1 }],
      });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "Purchase", {
        value: Number(value || 0),
        currency,
        content_ids: [serviceType],
        content_name: serviceName,
        content_type: "product",
      });
    }
  } catch {
    /* never throw */
  }
}

export function trackInitiateCheckout({ rail, serviceType }) {
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "begin_checkout", { rail, item_id: serviceType });
    }
    if (typeof window.fbq === "function") {
      window.fbq("track", "InitiateCheckout", { content_ids: [serviceType], rail });
    }
  } catch {
    /* never throw */
  }
}
